export default {
  googleMap: "AIzaSyDK61IzMb43Wp83Ydepp8893YNwtpqyq9M",
  google: {
    clientId:
      "1068762291149-4hp38v0d121vomh8ao9nvbhlofi3n5ms.apps.googleusercontent.com",
  },
};
